import React from "react";

import { Icon } from "components/Icon";
import styled, { css } from "styled-components";

import { RATECARD_LIST_DEFAULT_DIALER, SMS_RATECARD_LIST_DEFAULT_DIALER } from "const/apiMethods";
import { USD_DEFAULT_CURRENCY_KEY, EUR_DEFAULT_CURRENCY_KEY } from "const";
import { downloadDataAsFile, onDownloadPdf } from "utils/helpers";
import { getFileResponse } from "api/loginRoutes";
import { servicePick } from "utils";


import { ButtonToolbar, Dropdown, Loader } from "rsuite";

export default ({
    cur_key,
    service,
    str = "",
    sp_key,
    p_key,
    otpType,
    account,
    modal = false,
    getTemplate,
    ...props
}) => {
    const defaultCurKey = servicePick(service, USD_DEFAULT_CURRENCY_KEY, EUR_DEFAULT_CURRENCY_KEY);
    const curKey = cur_key || defaultCurKey;

    const [loading, setLoading] = React.useState(false);

    const exportFile = async () => {
        setLoading(true);

        const method = otpType === null
            ? servicePick(service, RATECARD_LIST_DEFAULT_DIALER, SMS_RATECARD_LIST_DEFAULT_DIALER)
            : "ratecard_otp:get_default_price";

        const result = await getFileResponse(method, {
            filter: { str, cur_key: curKey, sp_key },
        });

        if (result) {
            downloadDataAsFile(result, "prices.csv");
        }

        setLoading(false);
    };

    const exportActualSppFile = async (withPrice = false) => { // withPrice: true - with price, false - without price, null - all
        setLoading(true);
        const result = await getFileResponse("service_plan_price:get_list_actual", {
            filter: {},
            cur_key: curKey,
            p_key,
            with_price: withPrice
        });
        if (result) {
            downloadDataAsFile(result, "prices.csv");
        }
        setLoading(false);
    };

    const exportActualSppFileWithoutPrice = () => {
        exportActualSppFile(false);
    };
    const exportActualSppFileWithPrice = () => {
        exportActualSppFile(true);
    };
    const exportActualSppFileAll = () => {
        exportActualSppFile(null);
    };

    const methodPDF = otpType === null
        ? servicePick(service, RATECARD_LIST_DEFAULT_DIALER, SMS_RATECARD_LIST_DEFAULT_DIALER)
        : "ratecard_otp:get_default_price";

    const paramsPDF = { filter: { str, cur_key, sp_key } };


    return (
        <StyledButtonToolbar>
            <StyledDropdown
                size="sm"
                title={<>
                    {loading
                        ? <StyledLoader />
                        : <><Icon icon="upload2" />Export</>
                    }
                </>}
                appearance="default"
                disabled={loading}
                placement="bottomEnd"
            >

                <Dropdown.Item
                    onClick={exportFile}
                >
                    Export price list with ranges
                </Dropdown.Item>

                <Dropdown.Item
                    onClick={() => onDownloadPdf(account, paramsPDF, methodPDF, getTemplate)}
                >
                    Export price list with ranges (PDF)
                </Dropdown.Item>

                {!modal &&
                    <Dropdown.Item
                        onClick={exportActualSppFileAll}
                    >
                        Export subdestination list (full)
                    </Dropdown.Item>
                }

                {!modal &&
                    <Dropdown.Item
                        onClick={exportActualSppFileWithPrice}
                    >
                        Export subdestination list (with rates)
                    </Dropdown.Item>
                }

                {!modal &&
                    <Dropdown.Item
                        onClick={exportActualSppFileWithoutPrice}
                    >
                        Export subdestination list (without rates)
                    </Dropdown.Item>
                }

            </StyledDropdown>
        </StyledButtonToolbar>
    );
};

const StyledButtonToolbar = styled(ButtonToolbar)`
    display: inline-block; 
    ${props => props.width && css`
        width: ${props.width};
    `}
`;

const StyledDropdown = styled(Dropdown)`
    &:not(.rs-dropdown-menu) {
        height: 30px;
    }
    & .rs-btn {
        padding-left: 10px !important;
    }
    & .rs-loader-spin {
        margin-top: 0 !important;
    }
    & > .rs-dropdown-toggle {
        padding-top: 5px !important;
        top: 0;
        height: 30px;
        width: 100%;
    }
    & .rs-dropdown-toggle-caret {
        top: 5px;
        margin-top: 0 !important;
    }
`;

const StyledLoader = styled(Loader)`
    & span.rs-loader-spin {
        margin-top: 3px;
        margin-right: 5px;
    }
`;
